/*
 * returns function that checks received props for pre-existing values
 * and returns those in case they are there (truthy value for the values prop)
 * */
export default function genValueMapper (values: any) {
  return (props: any) => {
    return {
      ...values,
      ...props.values,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/form-utils/gen-value-mapper.ts